'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SimpleButton = require('../../generic/SimpleButton');

var _SimpleButton2 = _interopRequireDefault(_SimpleButton);

var _LoginForm = require('../../login/LoginForm');

var _LoginForm2 = _interopRequireDefault(_LoginForm);

var _MainStore = require('../../../stores/MainStore');

var _MainStore2 = _interopRequireDefault(_MainStore);

var _LoginStore = require('../../../stores/LoginStore');

var _LoginStore2 = _interopRequireDefault(_LoginStore);

var _Utility = require('../../../utils/Utility');

var Utility = _interopRequireWildcard(_Utility);

var Utils = _interopRequireWildcard(_Utility);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _SpinButton = require('../../generic/SpinButton');

var _SpinButton2 = _interopRequireDefault(_SpinButton);

var _ScheduleScreenStore = require('../../../stores/ScheduleScreenStore');

var _ScheduleScreenStore2 = _interopRequireDefault(_ScheduleScreenStore);

var _CartStore = require('../../../stores/CartStore');

var _CartStore2 = _interopRequireDefault(_CartStore);

var _Api = require('../../../utils/Api');

var _Api2 = _interopRequireDefault(_Api);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import LoginFormModal from "../../login/login-form";

var LOGIN_MODAL_ID = "LoginModal";
var CartLoginSection = (0, _createReactClass2.default)({
    displayName: 'CartLoginSection',
    getInitialState: function getInitialState() {
        return {
            isAccountActive: true,
            isGuest: true,
            title: "Please Sign In",
            dontShowCrossButton: false,
            disableDefaultClose: true,
            view: {
                showLoginModal: false
            }
        };

        // this.onLoginUpdate     = this.onLoginUpdate.bind(this);
    },


    // onLoginUpdate(event, currentUser) {
    //     if(!Utils.isEmptyObj(currentUser)){
    //         this.props.callbackParent(true);
    //     }else{
    //         this.props.callbackParent(false);
    //     }
    // },


    loginInformation: function loginInformation(isSuccess) {
        var updateProfile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        if (isSuccess) {

            $('#loginModal').modal('hide');

            this.setState({
                view: { showLoginModal: false }
            });

            this.props.callbackParent(true);
        }

        if (updateProfile) {
            this.setState({
                view: { showUserProfileStr: true }
            });
        }
    },
    handleHideLoginModal: function handleHideLoginModal() {
        this.setState({
            view: { showLoginModal: false },
            title: "Please Sign In",
            isGuest: true
        });
    },
    handleShowLoginModal: function handleShowLoginModal() {
        //bootstrap modal show on comp mount.
        this.setState({
            view: { showLoginModal: true },
            isGuest: false
        }, function () {
            $('#loginModal').modal('show');
        });
    },
    changeModalTitle: function changeModalTitle(title) {
        this.setState({ title: title });
    },
    changeCloseBehaviour: function changeCloseBehaviour(disableDefaultClose, dontShowCrossButton) {
        this.setState({
            disableDefaultClose: disableDefaultClose,
            dontShowCrossButton: dontShowCrossButton
        });
    },
    handleGuestLogin: function handleGuestLogin() {
        // console.log("guest login"
        this.setState({
            isGuest: true
        });
    },
    render: function render() {
        var title = this.state.title;

        var isLogoSameForAllLocation = _MainStore2.default.isLogoSameForAllLocation();
        var logo = "";

        if (isLogoSameForAllLocation && isLogoSameForAllLocation == true) {
            var businessData = _MainStore2.default.getBusinessDetail();
            logo = Utility.getLogoUrl(businessData);
        } else {
            var activeLocation = _MainStore2.default.getActiveLocation();
            logo = Utility.getLogoUrl(activeLocation);
        }

        var loginModal =

        // <Modal
        //     show={this.state.view.showLoginModal}
        //     onHide={this.handleHideLoginModal}
        //     size="md"
        //     centered
        // ><Modal.Body>
        //     <Modal.Header closeButton={true}>
        //         <Modal.Title as='h4' id="edit-profile" className={"font-weight-bold mt-0" +
        //             " text-center"}>{this.state.title}</Modal.Title>
        //     </Modal.Header>
        //     <LoginForm
        //         logo                 = {logo}
        //         callbackParent       = {this.loginInformation}
        //         changeModalTitle     = {this.changeModalTitle}
        //         changeCloseBehaviour = {this.changeCloseBehaviour}
        //         enableProfileEdit    = {true}
        //         history = {this.props.history}
        //         locId = {this.props.locId}
        //     />
        //     </Modal.Body>
        // </Modal>

        _react2.default.createElement(
            'div',
            { className: 'modal fade', id: 'loginModal', tabIndex: '-1', role: 'dialog',
                'aria-labelledby': 'exampleModalCenterTitle', 'aria-hidden': 'true',
                'data-keyboard': 'false', 'data-backdrop': 'static'
            },
            _react2.default.createElement(
                'div',
                { className: 'modal-dialog modal-dialog-centered', role: 'document' },
                _react2.default.createElement(
                    'div',
                    { className: 'modal-content' },
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-header' },
                        _react2.default.createElement(
                            'h5',
                            { className: 'modal-title font-weight-bold mt-0 text-center', id: 'exampleModalLongTitle' },
                            this.state.title
                        ),
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-label': 'Close', onClick: this.handleHideLoginModal },
                            _react2.default.createElement(
                                'span',
                                { 'aria-hidden': 'true' },
                                '\xD7'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: "modal-body" },
                        _react2.default.createElement(_LoginForm2.default, {
                            logo: logo,
                            callbackParent: this.loginInformation,
                            changeModalTitle: this.changeModalTitle,
                            changeCloseBehaviour: this.changeCloseBehaviour,
                            enableProfileEdit: true,
                            history: this.props.history,
                            locId: this.props.locId
                        })
                    )
                )
            )
        );

        return _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
                'div',
                { className: 'bg-white rounded shadow-sm p-4 mb-3' },
                _react2.default.createElement(
                    'div',
                    { className: 'border-bottom' },
                    _react2.default.createElement(
                        'h5',
                        { className: 'mb-1 cart-heading f16-default' },
                        'Account'
                    ),
                    _react2.default.createElement(
                        'h6',
                        { className: 'mb-2 text-black-50' },
                        !this.state.isGuest ? "Already have an account?" : "Checkout as a Guest."
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'mt-3' },
                    _react2.default.createElement(_SpinButton2.default, {
                        classNames: 'btn btn-sm btn-styl font-weight-bold px-4 pr-4',
                        buttonText: 'Guest',
                        spinText: "Loading...",
                        showSpinner: false,
                        whenClicked: this.handleGuestLogin,
                        showIcon: true,
                        iconClass: "fa fa-light fa-user mr-1",
                        tabIndex: 8
                    }),
                    _react2.default.createElement(_SpinButton2.default, {
                        classNames: 'btn btn-sm btn-login font-weight-bold custom-btn-outline-primary px-4 pr-4 ml-3',
                        buttonText: 'LogIn / SignUp',
                        spinText: "Loading...",
                        showSpinner: false,
                        whenClicked: this.handleShowLoginModal,
                        showIcon: true,
                        iconClass: "fa fa-regular fa-arrow-right-to-line mr-1",
                        tabIndex: 9
                    })
                )
            ),
            _react2.default.createElement('div', { className: 'pt-2' }),
            this.state.view.showLoginModal ? loginModal : null
        );
    }
});

exports.default = CartLoginSection;


//////////////////
// WEBPACK FOOTER
// ./src/components/cart-view/cart-left/CartLoginSection.jsx
// module id = 737
// module chunks = 0